module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isSubmitButtonLoading": _vm.isCancellingLesson,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      },
      "confirm": _vm.onConfirmCancelLesson
    }
  }, [_c('div', {
    attrs: {
      "slot": "custom_warning"
    },
    slot: "custom_warning"
  }, [(!_vm.isCanceled) ? [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_cancel_title))]), _vm._v(" "), _c('p', {
    staticClass: "pad-1 italic pad-0-top"
  }, [_vm._v(_vm._s(_vm.i18n.confirm_cancel_text))])] : [_c('h4', [_vm._v(_vm._s(_vm.i18n.confirm_uncancel_title))]), _vm._v(" "), _c('p', {
    staticClass: "pad-1 italic"
  }, [_vm._v(_vm._s(_vm.i18n.confirm_uncancel_text))])]], 2), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "confirmText"
    },
    slot: "confirmText"
  }, [_vm._v(_vm._s(!_vm.isCanceled ? _vm.i18n.cancel_event : _vm.i18n.uncancel_event))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68c09fac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/DModalCancelLesson.vue
// module id = 1978
// module chunks = 1